package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.data.mappers.SerializableMappers
import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.plandefinition.data.remote.dto.plan.BasePlanDto
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.BasePlanRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.serialization.modules.SerializersModule

class BasePlanRepositoryImpl(
    firestore: FirebaseFirestore,
    dtoSerializersModule: SerializersModule,
    mapper: SerializableMappers<BasePlan, BasePlanDto>,
) : BasePlanRepository, BaseFirestoreRepository<BasePlan, BasePlanDto>(
    firestore = firestore,
    dtoSerializersModule = dtoSerializersModule,
    mapper = mapper,
) {
    override suspend fun addDto(dto: BasePlanDto, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }

    override suspend fun setDto(dto: BasePlanDto, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }

    override suspend fun getDto(doc: DocumentSnapshot): BasePlanDto = doc.data { serializersModule = dtoSerializersModule }

}
